module.exports = __webpack_public_path__ + "static/media/jennifer_1584799703310.03562776.png";